import React from "react";

import { useTranslation } from "react-i18next";

import { bustleBeeForCustomer } from "../Customer/bustleBees";
import { Customer } from "../Customer/schema";
import { CustomerTab } from "../CustomerTab/schema";
import { BillSplit } from "./schema";
import { hasCustomerPaidIn, getOrderItemCountIn } from "./selectors";

export const Pill = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-center gap-4 py-4 px-12 bg-venue-tertiary rounded-venue-brand">
      {children}
    </div>
  );
};
export const CustomerPill = ({
  customer,
  count,
  paid,
}: {
  customer: Customer;
  count: number;
  paid: boolean;
}) => {
  const { t } = useTranslation();
  const bustleBee = bustleBeeForCustomer(customer);

  return (
    <div className="flex items-center whitespace-nowrap justify-center gap-4 py-4 px-12 bg-venue-tertiary rounded-full">
      {bustleBee && (
        <div className="h-32 w-32 p-4">
          <img src={bustleBee.img_96} alt={bustleBee.alt} />
        </div>
      )}
      <div>
        {customer.nickname}{" "}
        {paid ? (
          <span className="text-venue-highlight italic ">
            {t("billSplit.paid")}
          </span>
        ) : (
          t("billSplit.customerPillCount", {
            orderItemCount: count,
          })
        )}
      </div>
    </div>
  );
};
export const CustomerPillList = ({
  billSplit,
  customerTab,
  currentCustomer,
}: {
  billSplit: BillSplit;
  customerTab: CustomerTab;
  currentCustomer: Customer;
}) => {
  const { t } = useTranslation();
  const getHasCustomerPaid = hasCustomerPaidIn(billSplit);
  const getCustomersOrderItemCount = getOrderItemCountIn(
    billSplit,
    customerTab
  );
  const otherCustomers = billSplit.customers.filter(
    (c) => c.uuid != currentCustomer.uuid
  );
  return (
    <div className="flex gap-x-8 gap-y-8 overflow-x-auto">
      <CustomerPill
        customer={{ ...currentCustomer, nickname: t("customer.you") }}
        count={getCustomersOrderItemCount(currentCustomer)}
        paid={getHasCustomerPaid(currentCustomer)}
      />
      {otherCustomers.map((customer) => (
        <div className="flex-none">
          <CustomerPill
            customer={customer}
            count={getCustomersOrderItemCount(customer)}
            paid={getHasCustomerPaid(customer)}
          />
        </div>
      ))}
    </div>
  );
};
